import {ApplicationConfig, importProvidersFrom, mergeApplicationConfig} from '@angular/core';
import {FIREBASE_ANALYTICS, FIREBASE_REMOTE_CONFIG, FIREBASE_SERVER_REMOTE_CONFIG} from './module.di.tokens';
import {getRemoteConfig} from '@firebase/remote-config';
import {commonConfig, firebaseApp} from './app.common.config';
import {PixelModule} from 'ngx-multi-pixel';
import {environment} from '../../environments/environment';
import {getAnalytics} from '@firebase/analytics';

const browserConfig: ApplicationConfig = {
  providers: [
    {provide: FIREBASE_REMOTE_CONFIG, useFactory: () => getRemoteConfig(firebaseApp)},
    {provide: FIREBASE_ANALYTICS, useFactory: () => getAnalytics(firebaseApp)},
    {provide: FIREBASE_SERVER_REMOTE_CONFIG, useValue: null},
    importProvidersFrom(PixelModule.forRoot({ enabled: true, pixelId: [environment.pixelId]})),
  ],
};

export const config = mergeApplicationConfig(commonConfig, browserConfig);
